module.exports = __webpack_public_path__ + "img/Beginner-2.29862f67.gif";